<div class="thumbnails">
  <div class="thumbnails-title" [innerHtml]="titleText"></div>
  <div class="thumbnails-boxes">
    <div *ngFor="let asset of assets">
      <div [attr.id]="asset.index" *ngIf="asset.src">
        <div class="thumbnails-box-title">
          <div class="thumbnails-box-title-text">{{ indexText }} {{ asset.index + 1 }}</div>
          <span class="thumbnails-box-title-trash fa fa-trash" (click)="onAssetDelete(asset)"></span>
        </div>
        <div
          [ngClass]="{
            'thumbnails-box-selected': isSelectedAsset(asset),
            'thumbnails-box': !isSelectedAsset(asset)
          }"
          (click)="onAssetSelected(asset)"
        >
          <div [ngSwitch]="isVideoType(asset)">
            <img alt="thumbnail-img" [attr.src]="asset.src" class="image" *ngSwitchCase="false" />
            <video width="156" height="78" *ngSwitchCase="true">
              <source [attr.src]="asset.src" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
      <div *ngIf="!asset.src">
        <div class="thumbnails-box-title">
          <div class="thumbnails-box-title-text">{{ indexText }} {{ asset.index + 1 }}</div>
          <span class="thumbnails-box-title-trash fa fa-trash" (click)="onAssetDelete(asset)"></span>
        </div>
        <div
          [ngClass]="{
            'thumbnails-box-selected': isSelectedAsset(asset),
            'thumbnails-box': !isSelectedAsset(asset)
          }"
          (click)="onAssetSelected(asset)"
        ></div>
      </div>
    </div>
    <div *ngIf="assets?.length < maxAssetCount">
      <div class="thumbnails-box-title">
        <div class="thumbnails-box-title-text">{{ addText }}</div>
        <div></div>
      </div>
      <div class="thumbnails-add" (click)="onAssetAdd()">+</div>
    </div>
  </div>
</div>
